// extracted by mini-css-extract-plugin
module.exports = {"moreReviewsContainer":"ClassicReviewList_moreReviewsContainer__i7pQB"};